import type { ReactNode } from 'react'

// Minimal inline markdown — no dependency. Supports the subset the report
// paragraphs use: **bold**, *italic*, `code`, and paragraph / line breaks.
// Blank lines split <p>; single newlines become <br/>.

function renderInline(text: string, keyBase: string): ReactNode[] {
  const nodes: ReactNode[] = []
  const re = /(\*\*[^*]+\*\*|\*[^*]+\*|`[^`]+`)/g
  let last = 0
  let i = 0
  let match: RegExpExecArray | null
  while ((match = re.exec(text)) !== null) {
    if (match.index > last) nodes.push(text.slice(last, match.index))
    const token = match[0]
    const key = `${keyBase}-${i++}`
    if (token.startsWith('**')) nodes.push(<strong key={key}>{token.slice(2, -2)}</strong>)
    else if (token.startsWith('`')) nodes.push(<code key={key}>{token.slice(1, -1)}</code>)
    else nodes.push(<em key={key}>{token.slice(1, -1)}</em>)
    last = match.index + token.length
  }
  if (last < text.length) nodes.push(text.slice(last))
  return nodes
}

export function renderMarkdown(text: string): ReactNode {
  const paragraphs = text.trim().split(/\n\s*\n/)
  return paragraphs.map((para, pi) => {
    const lines = para.split('\n')
    return (
      <p key={pi}>
        {lines.map((line, li) => (
          <span key={li}>
            {renderInline(line, `${pi}-${li}`)}
            {li < lines.length - 1 ? <br /> : null}
          </span>
        ))}
      </p>
    )
  })
}
